import moment from 'moment-timezone';
import 'moment/locale/es';

const epochToLocalDate = (epoch, locale) => {
	// Use Mexico City timezone for consistent date display across all users
	// let timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
	let timezone = 'America/Mexico_City';
	moment.locale(locale);
	let momentTime = moment(epoch).tz(timezone).format('L LTS');

	return momentTime;
}

const cycleDaysInfo = (startDate, endDate) => {
	let start = moment(startDate);
	let end = moment(endDate);
	let today = moment();

	let cycleDays = end.diff(start, 'days') + 1;

	let daysOff = 0;
	for (let day = start; day.isBefore(end); day.add(1, 'days')) {
		if (day.day() === 0) {
			daysOff++;
		}
	}

	start = moment(startDate);
	let currentDays = -1;
	for (let day = start; day.isBefore(today); day.add(1, 'days')) {
		if (day.day() !== 0) {
			currentDays++;
		}
	}

	let workingDays = cycleDays - daysOff;
	let remainingDays = workingDays - currentDays;

	return [workingDays, currentDays, remainingDays];
}

const getDayInitial = (dateString) => {
	const [year, month, day] = dateString.split('-');
	const date = new Date(year, month - 1, day);
	const dayOfWeek = date.getDay();
	const initials = ['D', 'L', 'M', 'W', 'J', 'V', 'S'];
	return initials[dayOfWeek];
}

export { epochToLocalDate, cycleDaysInfo, getDayInitial };
